import { ROOT_JOURNAL_URL } from '@/shared/constants/urlConstants';
import { mapColumnsArrays } from '@/shared/utils/mapColumnsArrays';

import type { IJournalTopic } from '@/entities/journal/model/types';
import type { BreadcrumbDropdownItem } from '@/shared/ui/AppBreadcrumbs/model/types/appBreadcrumbs';

const TOPICS_PER_PAGE = 100;

export const useJournalTopics = (activeTopicSlug?: ComputedRef<string>) => {
  const { $journalService } = useNuxtApp();

  const { data } = useAsyncData<IJournalTopic[]>(
    'journal-topics',
    async () => {
      const response = await $journalService.getTopics({ per_page: TOPICS_PER_PAGE });
      return response.data ?? [];
    },
    { default: () => [] },
  );

  const journalTopics: ComputedRef<IJournalTopic[]> = computed(() => data.value ?? []);

  const journalTopicsDropdownItems: ComputedRef<BreadcrumbDropdownItem[]> = computed(() =>
    journalTopics.value.map((topic) =>
      mapColumnsArrays(
        topic,
        `${ROOT_JOURNAL_URL}${topic.slug}/`,
        'topics',
        false,
        false,
        topic.slug === activeTopicSlug?.value ? '_selected' : '',
      ),
    ),
  );

  return {
    journalTopics,
    journalTopicsDropdownItems,
  };
};
